// extracted by mini-css-extract-plugin
module.exports =  {"container":"WithNAFallback-module__container--MxF0e","text":"WithNAFallback-module__text--_QXqU","useDash":"WithNAFallback-module__useDash--n_IXN"};